import styled, { css } from 'styled-components';
import { Flex, Text } from 'ui';

const TERMS = [
  {
    term: 'Commodity',
    description: 'the commodity code identifying the product or item.',
  },
  {
    term: 'Index name',
    description:
      'the index from the source file used to identify a specific item or record, e.g. a commodity code, order number, or quote number.',
  },
  {
    term: 'Skipped',
    description:
      'the record was excluded from processing because it was listed in a PRODAT/PARTIN negative file.',
  },
  {
    term: 'Structure',
    description:
      'the file contains structural issues and could not be fully imported.',
  },
];

export const ImportLogsLegend = () => (
  <Container flexDirection="column">
    <Text fontWeight="bold" mb="s10">
      Terminology
    </Text>
    {TERMS.map(({ term, description }) => (
      <Text key={term} lineHeight="lh300">
        <Text fontWeight="bold">{term}</Text>
        {` — ${description}`}
      </Text>
    ))}
  </Container>
);

const Container = styled(Flex)`
  ${({ theme: { space, colors } }) => css`
    padding: ${space.s20};
    border: 1px solid ${colors.blue};
    border-radius: 4px;
    background: ${colors.lightBlue};
  `}
`;
